import { render, staticRenderFns } from "./MarketingTemplates.vue?vue&type=template&id=58bd4e5f&"
import script from "./MarketingTemplates.vue?vue&type=script&lang=js&"
export * from "./MarketingTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports